<div style="height: 100vh;">
    <div style=" display: inline;block-size: 10%;">

        <div class="col-md-12 col-sm-12 col-xs-12 pad0" style="padding: 15px 0px 10px 25px;">
    
            <div class="col-md-3 col-sm-3 col-xs-3" style="display: inline-block; padding: 0;">
    
                <h2 class="ng-binding lblHeader newHeader" style="font-size: 28px !important;">
                    Head Record
                </h2>
            </div>
    
            <div class="col-md-9 col-sm-9 col-xs-9" style="display: inline-block;text-align: right;">
    
                <!--Zero Hides-->
                <!-- <span style="display: inline-block;">
                    <span class="checkbox"  >
                        <label style="margin-bottom: 0px !important; line-height: 30px;font-size: 15px !important; cursor: pointer;">
                            <input type="checkbox" [(ngModel)]="hideZeroLevelLdgr" style="margin-right: 5px;">Hide
                            zeroes
                        </label>
                    </span>
                </span> -->
                <span class="label darkBlueBadge fntSz bgwhite darkBlueBrdr brdrRadius3" style="padding: 4px 8px !important; cursor: pointer;">
                    <label style="margin-bottom: 0px; margin-left: 0; cursor: pointer; vertical-align: middle;">
                        <input class="chkbox-darkblue" type="checkbox" [(ngModel)]="hideZeroLevelLdgr" (change)="zeroHide()" style="margin-right: 5px; vertical-align: text-top;">
                        Hide zeroes
                    </label>
                </span> 
    
                <!--search-->
                <span class="search">
                    <span class="fa fa-search"
                        style="position: relative;left: 3.5% !important; font-size: 14px; color: #777;"></span>
                    <input class="form-control brdrColor" ng-model="search.term" placeholder="Search" matInput
                        (keyup)="applyFilter($event)" #input
                        style="text-align: left; display: inline-block; padding-left: 35px !important; border-radius: 3px !important; font-size: 13px; box-shadow: none; width: 18% !important; height: 30px !important;"
                        type="text">
                </span>
    
                <!--Print-->
                <!-- <span (click)="printVoucher()" title="Print Statement of Accounts" class="darkBlueButton" style="margin-left: 10px; cursor: pointer; line-height: 19px; padding: 5px 10px;">
                    <span>
                        <i aria-hidden="true" class="zmdi zmdi-print" style="font-size: 16px;"></i>
                    </span>
                </span> -->
    
                <!-- <span (click)="refresh()" class="btn btn-green"
                    style="cursor: pointer;line-height: 22px; padding: 5px 11px;" title="Refresh">
                    <span>
                        <i aria-hidden="true" style="font-size: 14px;" class="fa fa-refresh"></i>
                    </span>
                </span> -->
    
                <span (click)="exportToExcel()" class="darkBlueButton" style="margin-left: 10px; cursor: pointer; line-height: 19px; padding: 5px 10px;" title="Export to Excel">
                    <span>
                        <i aria-hidden="true" style="font-size: 14px;" class="fa fa-file-excel-o"></i>
                    </span>
                </span>
    
                <div style="display: inline-block; padding: 0px;" title="Back to Account Dashboard">
                    <span class="darkBlueButton"
                        style="font-size: 13px; display: inline-block; line-height: 19px; padding: 5px 8px 5px; margin-left: 10px;"
                        (click)="backBtn()">
                        <i class="fa fa-chevron-left" style="margin-right: 3px;"></i> Back
                    </span>
                </div>
            </div>
        </div>
    </div>
    
    <div class="col-md-12 col-xs-12 col-sm-12" style="padding-left: 25px; height: 40px; display: flex; align-items: center; column-gap: 8px;">
        <div style="display: inline-block;vertical-align: bottom;">
            <input class="form-control font13 brdrRadius3" placeholder="Select Heads" list="HeadNameList" [(ngModel)]="HeadName"  style="border: 1px solid #BCC2C9 !important; display: inline-block; width: 100%; background-color: white !important; max-width: 180px;" (blur)="openSubHeadList(HeadName)" >
    
            <datalist class="font13" id="HeadNameList">
              <option *ngFor="let h of headDataList" [value]="h.HeadName"> {{h.HeadName}}</option>
            </datalist>
        </div>
        <div style="display: inline-block;font-size: 14px !important;padding-left: 0px;">
            <!--Financial Years-->
            <div style="display: flex; justify-content: center; align-items: center; column-gap: 8px; padding-left: 0px;">
                <select class="form-control font12 formCtlFltr BzBgwhite brdrRadius3" style="display: block; box-shadow: none; font-size: 12px; background-color: white !important; width: 150px !important;" [(ngModel)]="selectedFY" (ngModelChange)="ddlchangeYear()" [style.width]="selectedFY == 'Other' ? '90px' : '130px'">
                    <option *ngFor="let f of financialYears" [ngValue]="f.FY">FY {{f.FY}}</option>
                    <option value="Other">Other</option>
                </select>
    
                <div style="display: flex; align-items: center; font-size: 13px !important; column-gap: 10px;"
                    *ngIf="selectedFY == 'Other'">
                    <div style="outline: none !important; display: flex; align-items: center;">
                        <input matInput readonly disabled="{{disable.fromInput}}" (focus)="picker.open()" [(ngModel)]="fromDate" [matDatepicker]="picker" class="form-control font12 formCtlFltr BzBgwhite brdrRadius3" style="display: block; box-shadow: none; font-size: 12px; background-color: white !important; width: 90px !important; padding: 0 8px;box-sizing: border-box;">
                        <mat-datepicker #picker style="outline: none !important;"></mat-datepicker>
                    </div>
                    <div style="font-size: 15px !important; display: inline-block;">
                        to</div>
                    <div style="outline: none !important; display: flex; align-items: center;">
                        <input matInput readonly disabled="{{disable.toInput}}" (focus)="picker2.open()" [matDatepicker]="picker2" [(ngModel)]="toDate" class="form-control font12 formCtlFltr BzBgwhite brdrRadius3" style="display: block; box-shadow: none; font-size: 12px; background-color: white !important; width: 90px !important; padding: 0 8px; box-sizing: border-box;">
                        <mat-datepicker #picker2 style="outline: none !important;"></mat-datepicker>
                    </div>
                    <div>
                        <span *ngIf="show.edit" class="orangeButton" style="width: auto; height: 30px;" [(ngModel)]="show.edit" (click)="editPeriod()">
                            <i class="zmdi zmdi-edit" style="margin-right: 5px;"></i>
                            <span> Edit </span>
                        </span>
                        <span *ngIf="show.save" class="darkBlueButton" style="width: auto; height: 30px;" [(ngModel)]="show.save" (click)="changePeriod()">
                            <i class="zmdi zmdi-arrow-right" style="margin-right: 5px;"></i>
                            <span> Fetch </span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <div class="col-md-12 col-xs-12 col-sm-12 pad0" style="padding-right: 0px;padding-left: 25px;" #LRTable>
    
        <!--tree head & subhead open-->
        <div class="col-md-12 col-sm-12 col-12" style="display: inline-block; padding: 0px; left:5px; top: 10px; margin-bottom: 15px !important;">
            <div class="tree font13" style="display: inline-block; cursor: pointer;" *ngIf="isShowSubHeads"
                (click)="allHeads()">All</div>
            <div *ngFor="let t of tree; let i = index" style="display: inline-block; cursor: pointer; font-size: 13px;"
                (click)="treeIndex(t, i)">
                <span style="margin: 0px 5px;"> > </span> <span class="tree">{{t.headName}}</span>
            </div>
        </div>
    
        <table mat-table [dataSource]="dataSource" class="shadow" matSort style="border-radius: 3px; border-bottom-right-radius: 0px !important; border-bottom-left-radius: 0px !important;">
            <ng-container matColumnDef="head">
                <th class="header header-Table" style="cursor: pointer;" mat-header-cell *matHeaderCellDef mat-sort-header>
                    Head
                </th>
                <td mat-cell *matCellDef="let item;let i=index" (click)="openSubHead(item,HeadID)"
                    style="text-align: left; cursor: pointer; width:20%; font-weight: {{ item.isHead == true ? '600' : 'normal'}}; color: {{ item.isHead == true ? '#e88421' : '#1F628E' }};">
                    {{item.name}}
                </td>
            </ng-container>
    
            <ng-container matColumnDef="opening">
                <th class="header header-Table" style="margin-left: 10px !important; cursor: pointer;" mat-header-cell
                    *matHeaderCellDef mat-sort-header arrowPosition='before'>
                    <label style="cursor: pointer; margin-left: 0;">Opening</label>
                </th>
                <td mat-cell *matCellDef="let item;let i=index" style="text-align: right; width: 10%; cursor: pointer;">
                    {{item.OpBal | cRDB }}
                </td>
            </ng-container>
    
            <ng-container matColumnDef="debit">
                <th class="header header-Table" style="cursor: pointer;" mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition='before'>
                    <label style="cursor: pointer; margin-left: 0;">Debit</label>
                </th>
    
                <td mat-cell *matCellDef="let item ;let i=index" style="text-align: right; width: 10%; cursor: pointer;">
                    {{item.DbAmt | lacFormat }}
                </td>
            </ng-container>
    
            <ng-container matColumnDef="credit">
                <th class="header header-Table" style="cursor: pointer;" mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition='before'>
                    <label style="cursor: pointer; margin-left: 0;">Credit</label>
                </th>
                <td mat-cell *matCellDef="let item ;let i=index" style="text-align: right; cursor: pointer;width: 10%;">
                    {{item.CrAmt | lacFormat }}
                </td>
            </ng-container>
    
            <ng-container matColumnDef="closing">
                <th class="header header-Table" style="cursor: pointer;" mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition='before'>
                    <label style="cursor: pointer; margin-left: 0;">Closing</label>
    
                </th>
                <td mat-cell *matCellDef="let item ;let i=index" style="text-align: right; cursor: pointer;width: 10%;">
                    {{item.CloBal | cRDB }}
                </td>
            </ng-container>
    
            <!-- <ng-container matColumnDef="CloBal">
                <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
                    style="text-align: right; cursor: pointer;">
                    <label style="cursor: pointer;">Balance</label>
                </th>
                <td mat-cell *matCellDef="let item ;let i=index" style="text-align: right ;cursor: pointer;">₹
                    {{ item.newCloBal | cRDB}}
                    
                </td>
            </ng-container> -->
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let item; columns: displayedColumns;"></tr>
        </table>
    
        <!-- Angular 8 pagination -->
        <mat-paginator #paginator [pageSize]="10" [pageSizeOptions]="[5,10, 20]" showFirstLastButtons
            class="shadow" style="width: 70%; border-radius: 3px;">
        </mat-paginator>
    
    </div>
</div>